import { Action } from '../action';
import { ResourceType } from '../resourceType';
export const permissionSchema = {
    $id: 'urn:wisepipe-domain-authorize:Permission',
    type: 'object',
    properties: {
        resourceType: {
            type: 'number',
            enum: Object.keys(ResourceType)
                .map((key) => parseInt(key))
                .filter((key) => !isNaN(key))
        },
        resourceID: { type: 'string', minLength: 1 },
        action: {
            type: 'number',
            enum: Object.keys(Action)
                .map((key) => parseInt(key))
                .filter((key) => !isNaN(key))
        },
        level: { type: 'integer', minimum: 0 }
    },
    required: ['resourceType', 'resourceID', 'action']
};
//# sourceMappingURL=permission.js.map